import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import classNames from 'classnames';

import { useConfigCreate, useSuggetions } from '../../../../../api';
import { useTranslate, useValidation } from '../../../../../../../hooks';

import { addempportalmenuType } from '../validations';
import { CONFIG_ID, checkData, removeDuplicates } from '../../../../utils';

import { Button, TextInput } from '../../../../../../../components';
import { LoadingButton } from '../../../../../../../components/buttons';
import SuggestionList from '../../../../components/suggetions/SuggestionList';
import LoaderCotainer from '../../../../components/LoaderCotainer';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AddedListItem from '../../../../components/list/AddedListItem';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { CustomToast } from '../../../../../../../common/Methodcommon';
import { useEmpPortalMenuSuggestion } from '../api/use-emp-portal-menu-suggestion';
import { useEmpPortalMenuConfigCreate } from '../api/use-emp-portal-menu-config-create';

function AddEmpPortaMenuTypePage() {
  const { translate, isRTL } = useTranslate();
  const { compEmpTypeList } = useLocation().state;
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
  });
  const [addList, setAddList] = useState({ fromSuggetion: [], fromForm: [] });
  const [sugSeletedCount, setSugSeletedCount] = useState(0);

  const { errors, validate } = useValidation(addempportalmenuType, {
    name: form?.name,
  });
  const {
    data: suggetions,
    suggetionCount,
    isLoading,
  } = useEmpPortalMenuSuggestion();
  const { createConfig, isCreating } = useEmpPortalMenuConfigCreate({
    params: { configId: CONFIG_ID?.assetType },
  });

  const wholeList = [...addList?.fromSuggetion, ...addList?.fromForm];

  const handleSave = async (e) => {
    e.preventDefault();
    if (
      addList?.fromForm?.length === 0 &&
      addList?.fromSuggetion?.length === 0
    ) {
      return;
    }
    let payload = wholeList?.map((item) => ({
      name: item.name,
      isTemplate: 0,
    }));
    createConfig({ configs: payload }).then(() => navigate(-1));
  };

  const handleChange = ({ key, value }) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  //comparing suggestions list to know already added suggestions
  let suggetionsList = useMemo(() => {
    let newList = [];
    let selectedCount = 0;
    if (compEmpTypeList?.length > 0 || suggetions?.length) {
      const compEmpType = compEmpTypeList?.map((empType) => empType?.name);
      newList = suggetions?.map((empType, i) => {
        if (compEmpType?.includes(empType?.name)) {
          empType.isAdded = true;
          empType.immutable = true;
          selectedCount += 1;
        }
        return empType;
      });
    }
    setSugSeletedCount(selectedCount);
    return newList;
  }, [isLoading]);

  const addFromSuggetions = (suggestion, index) => {
    try {
      checkData({ data: suggestion, list: wholeList });
      setAddList((prev) => ({
        ...prev,
        fromSuggetion: [...prev?.fromSuggetion, suggestion],
      }));
      suggetionsList[index].isAdded = true;
      setSugSeletedCount((prev) => (prev += 1));
    } catch (error) {
      CustomToast('error', error?.message);
    }
  };

  const updateSuggetionList = ({ selectedSuggestion, status }) => {
    suggetionsList?.forEach((suggestion) => {
      if (
        suggestion.name == selectedSuggestion?.name &&
        !suggestion?.immutable
      ) {
        suggestion.isAdded = status;
      }
    });
  };

  const deleteFromSuggetions = (suggestion, deleteIndex) => {
    setAddList((prev) => {
      let newList = [];
      newList = prev?.fromSuggetion?.filter(
        (item, index) => deleteIndex !== index,
      );
      return { ...prev, fromSuggetion: newList };
    });

    updateSuggetionList({ selectedSuggestion: suggestion, status: false });
    setSugSeletedCount((prev) => (prev -= 1));
  };

  const deleteFromFormAdded = (suggestion, deleteIndex) => {
    setAddList((prev) => {
      let newList = [];
      newList = prev?.fromForm?.filter((item, index) => deleteIndex !== index);
      return { ...prev, fromForm: newList };
    });
  };

  const onAddAll = () => {
    if (suggetionCount === sugSeletedCount) {
      return;
    }
    let existingList = wholeList?.map((item) => item.name);

    suggetionsList?.forEach((item) => {
      if (!item?.immutable && !existingList.includes(item.name))
        item.isAdded = true;
    });
    setAddList((prev) => ({
      ...prev,
      fromSuggetion: removeDuplicates({ existingList, suggetionsList }),
    }));
    setSugSeletedCount(() => suggetionsList?.length);
  };

  const onDeleteAll = () => {
    suggetionsList?.forEach((item) => {
      if (!item?.immutable) item.isAdded = false;
    });
    setSugSeletedCount(
      suggetionsList?.filter((item) => item?.immutable)?.length,
    );
    setAddList(() => ({ fromForm: [], fromSuggetion: [] }));
  };
  return (
    <div className="bg-white overflow-y-auto">
      <span className="flex items-center gap-x-2 mb-3 h-[26px]">
        <span className="flex gap-1">
          <KeyboardBackspaceIcon
            className={classNames(
              'text-gray-400 transform cursor-pointer mr-2',
              {
                'rotate-180': isRTL,
              },
            )}
            onClick={() => navigate(-1)}
          />
          <p className="welcome-text font-bold">{translate('Add')}</p>
          <p className="welcome-text2 font-bold">{translate('Menu')}</p>
        </span>
      </span>
      <div className="w-full add-configuration-section-card-container">
        <div className="w-[33%] flex flex-col gap-[14px]">
          <div className="w-[100%]">
            {isLoading ? (
              <LoaderCotainer />
            ) : (
              <SuggestionList
                handleSuggestionSelect={addFromSuggetions}
                selectedCount={sugSeletedCount}
                suggetionCount={suggetionCount}
                suggetionsList={suggetionsList}
                onAddAll={onAddAll}
              />
            )}
          </div>
        </div>

        <div className="w-[33%] flex flex-col gap-[14px]">
          <div className="w-[100%] rounded-md !border-border !border-2 p-3 add-configuration-section-card ">
            <div className="w-full flex justify-between">
              <p className="text-primary text-sm tracking-[0.6px] font-semibold">
                {translate('Added')}
              </p>
              <Button
                className={`outline-btn min-w-[75px] shrink-0 px-2 pr-3 rounded-[4px] h-7 flex items-center gap-[5px]`}
                onClick={onDeleteAll}
              >
                <i className="las la-trash-alt text-error cursor-pointer !text-[16px]"></i>
                {translate('Delete All')}
              </Button>
            </div>
            <div className="overflow-y-auto flex flex-col mt-3 gap-2 mb-0 w-full added-list-section px-1">
              {addList?.fromForm?.map((item, index) => (
                <AddedListItem
                  key={item?.name}
                  value={item}
                  handleDelete={() => deleteFromFormAdded(item, index)}
                />
              ))}
              {addList?.fromSuggetion?.map((item, index) => (
                <AddedListItem
                  key={item?.name}
                  value={item}
                  handleDelete={() => deleteFromSuggetions(item, index)}
                />
              ))}
              {addList?.fromSuggetion?.length === 0 &&
                addList?.fromForm?.length === 0 && (
                  <div className="flex h-full items-center justify-center flex-col">
                    <FilterAltIcon className="!w-20 !h-20 text-gray-400" />
                    <p className="text-sm w-[80%] text-center">
                      {translate('Please add new type')}
                    </p>
                  </div>
                )}
            </div>
          </div>
          <div className="flex justify-end gap-4 w-full">
            <Button
              className={`outline-btn min-w-[75px] rounded-md`}
              onClick={() => navigate(-1)}
            >
              {translate('Cancel')}
            </Button>
            <LoadingButton
              className="primary-btn min-w-[75px] rounded-md"
              onClick={handleSave}
              isLoading={isCreating}
            >
              {translate('Save')}
            </LoadingButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddEmpPortaMenuTypePage;
